import { gql } from 'graphql-tag'

export const CREATE_CONSUMER_SUBMITTED_FEEDBACK = gql`
  mutation createConsumerSubmittedFeedback($feedbackInput: ConsumerSubmittedFeedbackInput!) {
    createConsumerSubmittedFeedback(feedbackInput: $feedbackInput) {
      consumerId
      orderId
      packageId
      clientId
      feedback
      createdAt
      updatedAt
    }
  }
`
